<template>
  <div>
    <div>
      <vue-good-table
        class="mx-4"
        :columns="columns"
        :rows="getBrandList"
        :line-numbers="false"
        :sort-options="{
          enabled: true,
          initialSortBy: {field: 'name', type: 'asc'}
        }"
        :search-options="{enabled: true,}">
        <div slot="emptystate">There are no entries</div>
        <div slot="table-actions">
        </div>
        >
        <template slot="table-row" slot-scope="props">
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import  {mapGetters, mapActions} from 'vuex';
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';

export default {
  name: 'BrandList',
  components: {
    VueGoodTable,
  },
  computed: mapGetters(['getBrandList']),
  methods: {
    ...mapActions(['fetchBrandList']),
  },
  async mounted() {
    await this.fetchBrandList();
  },
  data(){
    return {
      columns: [
        // {label: 'ID', field: 'id', type: 'text'},
        {label: 'Name', field: 'name', type: 'text'},
        // {label: 'URL', field: 'url', type: 'text'},
      ]
    }
  }
}
</script>

<style scoped lang="scss">
</style>
